interface IOutlineArrowUpIcon {
  size?: 'sm' | 'md';
  color?: string;
}

export const OutlineArrowUpIcon = (props: IOutlineArrowUpIcon) => {
  const { size = 'md', color = '#222530' } = props;
  return (
    <>
      {size === 'md' ? (
        <svg width="24" height="24" viewBox={`0 0 2424`} fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 15L12 9L6 15" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 10.8184L8 6.81836L4 10.8184" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </>
  );
};
